import styled from "styled-components";

export default styled.div`
  display: flex;
  flex-direction: column;
  gap: 34px;
  padding-bottom: 34px;

  .group-header {
    border-bottom: 1px solid #E5E7EB;
    margin-bottom: var(--size-lg);

    h3 {
      font-size: 20px;
      font-weight: 600;
      margin-bottom: 4px;
    }

    p {
      color: #667085;
      margin-bottom: var(--size-lg);
      font-weight: 500;
    }
  }

  .input-group {
    display: flex;
    gap: 8px;

    .ant-form-item {
      flex: 1;
    }
  }
`;
